const en = {
  b6: {
    description: "An educational platform for groomers: courses, methodology and practice tools.",
    about: "About Valeriia", public_cases: "Public Cases", privacy: "Privacy Policy", terms: "Terms of Use", refund: "Refund & Cancellation",
    site: "Website", legal: "Legal", contact: "Contact and support",
    copyright: "© {{year}} Valeriia. Operator: [To be supplied: operator / company name, address].",
    video_soon: "Introductory video — coming soon", video_title: "Introductory video", captions: "Captions", courses_link: "Courses and educational materials",
  },
  b4: { legal: "Draft — requires legal review before publication" },
  help: { email_tbc: "To be supplied" },
};

const ru = {
  b6: {
    description: "Образовательная платформа для грумеров: курсы, методология и инструменты практики.",
    about: "О Валерии", public_cases: "Публичные кейсы", privacy: "Политика конфиденциальности", terms: "Условия использования", refund: "Возврат и отмена",
    site: "Сайт", legal: "Правовая информация", contact: "Контакты и поддержка",
    copyright: "© {{year}} Valeriia. Оператор: [Будет предоставлено: название оператора / компании, адрес].",
    video_soon: "Вводное видео — скоро", video_title: "Вводное видео", captions: "Субтитры", courses_link: "Курсы и учебные материалы",
  },
  b4: { legal: "Черновик — требует юридической проверки перед публикацией" },
  help: { email_tbc: "Будет предоставлено" },
};

export default { en, ru };
